import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'zorrly-description',
  standalone: true,
  imports: [
    CommonModule
  ],
  template: `
      <div [innerHTML]="html"></div>
  `,
})
export class ZorrlyInfoComponent extends FieldType {
  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  get html(): any {
    return this.sanitizer.bypassSecurityTrustHtml(this.props.html);
  }
}
